import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext.jsx';
import { LegalModal } from './Modals.jsx';

const KEY = 'wb_consent_v1';

export const ConsentBanner = () => {
  const { t } = useLanguage();
  const [seen, setSeen] = useState(() => localStorage.getItem(KEY) === '1');
  const [open, setOpen] = useState(null); // 'privacy' | 'terms' | null
  if (seen) return null;
  const accept = () => { localStorage.setItem(KEY, '1'); setSeen(true); };
  return (
    <>
      <div className="consent" role="dialog" aria-live="polite" aria-label={t.footer.privacy}>
        <p>
          {t.consent.text}{' '}
          <button type="button" onClick={() => setOpen('privacy')}>{t.footer.privacy}</button>
          {' · '}
          <button type="button" onClick={() => setOpen('terms')}>{t.footer.terms}</button>
        </p>
        <button type="button" className="btn sm primary" onClick={accept}>{t.consent.ok}</button>
      </div>
      {open === 'privacy' && <LegalModal doc={t.privacy} tone="info" icon="shield" onClose={() => setOpen(null)} />}
      {open === 'terms' && <LegalModal doc={t.terms} tone="brand" icon="gavel" onClose={() => setOpen(null)} />}
    </>
  );
};

